import { startOfDay, addDays, isAfter, isBefore, isEqual, format, parse } from 'date-fns'

/**
 * Returns hoverDate if it is between today and the maxSelectable date (inclusive). Dates are formatted YYYYMMDD.
 * Otherwise, returns null.
 * @param hoveredDate
 * @param diff
 * @param maxSelectableDate
 * @param minSelectableDate
 * @returns {string|null|*}
 */
export function validateHoverDate(hoveredDate, diff, maxSelectableDate, minSelectableDate) {
  if (diff === 0) {
    return hoveredDate
  }

  const startOfToday = startOfDay(Date.now())
  const parsedMinSelectableDate = minSelectableDate && parse(minSelectableDate, 'yyyyMMdd', new Date())
  const minStartDate =
    parsedMinSelectableDate && isBefore(startOfToday, parsedMinSelectableDate)
      ? parsedMinSelectableDate
      : startOfToday
  const newSelection = addDays(startOfDay(parse(hoveredDate, 'yyyyMMdd', new Date())), diff)
  const startOfMaxDate = startOfDay(parse(maxSelectableDate, 'yyyyMMdd', new Date()))

  if (
    diff &&
    (isAfter(newSelection, minStartDate) || isEqual(newSelection, minStartDate)) &&
    isBefore(newSelection, startOfMaxDate)
  ) {
    return format(newSelection, 'yyyyMMdd')
  }

  return null
}
